import { List } from 'immutable';
import { HARDWARE_DEPENDENCIES } from '../utils/hardwareConstants';

// Internal action for adding a single item (keeps existing reducer logic)
export const UPDATE_TRUCK_ITEMS = 'UPDATE_TRUCK_ITEMS';
const updateTruckItemsInternal = (truckItem) => ({
    type: UPDATE_TRUCK_ITEMS,
    payload: truckItem,
});

/**
 * Thunk to add hardware item with automatic dependency resolution
 * @param {Object} truckItem - The hardware item to add
 * @param {Object} hardwareItems - Immutable Map of available hardware items
 */
export const addHardwareItemWithDependencies = (truckItem, hardwareItems) => {
    return (dispatch, getState) => {
        const state = getState();
        const installedItems = state.truckDesigner.truck
            .getIn(['selectedTruck', 'truckItems'], List([]))
            .map(item => item.get('itemName'))
            .toJS();
        
        const itemName = truckItem.itemName || truckItem.get?.('itemName');
        const hasDependencies = HARDWARE_DEPENDENCIES[itemName] || null;
        const requiredDependencies = hasDependencies ? HARDWARE_DEPENDENCIES[itemName].split(',') : [];
        
        console.log('requiredDependencies', requiredDependencies);
        requiredDependencies.forEach(requiredDependency => {
            // If this item requires a dependency and it's not already installed
            if (requiredDependency && !installedItems.includes(requiredDependency)) {
                const dependencyItemData = hardwareItems.get(requiredDependency);

                if (dependencyItemData) {
                    // Add dependency first
                    dispatch(updateTruckItemsInternal(dependencyItemData));
                }
            }
        })

        // Add the requested item
        dispatch(updateTruckItemsInternal(truckItem));
    };
};
